// otherwise the class names saved by the editor (e.g. __se__float-center) may not match the CSS.
export const SUN_EDITOR_VERSION = '2.47.8';
export const SUN_EDITOR_CSS_URL = `https://cdn.jsdelivr.net/npm/suneditor@${SUN_EDITOR_VERSION}/dist/css/suneditor.min.css`;
export const SUN_EDITOR_SCRIPT_URL = `https://cdn.jsdelivr.net/npm/suneditor@${SUN_EDITOR_VERSION}/dist/suneditor.min.js`;
